<template>
    <div>

        <!-- mensajes de confirmacion -->
        <mensajeSistema></mensajeSistema>

        <v-card>
            <!-- titulo y boton crear -->
            <v-row class="py-0" v-if="componenteEvento.agregar_submodulo">
                <v-col class="d-flex justify-space-between py-0">

                    <v-row class="pl-2">
                        <v-col cols="12" md="3" sm="3" class="py-0">
                            <v-autocomplete
                            @change="eventFiltroPais"
                            v-model="filtro.id_pais"
                            label="País"
                            :items="paisFiltro"
                            item-value="id"
                            item-text="nombre_pais"
                            autocomplete="off">
                            </v-autocomplete>
                        </v-col>

                        <v-col cols="12" md="3" sm="3" class="py-0">
                            <v-autocomplete
                            @change="eventFiltroNivel"
                            v-model="filtro.id_nivel"
                            label="Nivel"
                            :items="NivelesSearch"
                            item-value="id"
                            item-text="desc_nivel"
                            :disabled="disabledNivelSearch"
                            autocomplete="off"
                            >
                            </v-autocomplete>
                        </v-col>

                        <v-col cols="12" md="3" sm="3" class="py-0">
                            <v-autocomplete
                            @change="eventFiltroArea"
                            v-model="filtro.id_area"
                            label="Área"
                            :items="AreasSearch"
                            item-value="id"
                            item-text="desc_area"
                            :disabled="disabledAreaSearch"
                            autocomplete="off"
                            ></v-autocomplete>
                        </v-col>
                    </v-row>

                    <v-btn class="btn_block_style2" dark  @click="addItem">Crear Cursos</v-btn>

                </v-col>
            </v-row>



            <v-row class="py-0">

                <v-col cols="12" sm="12" md="auto" class="pl-5" v-for="item in Datos" :key="item.id">

                    <v-card width="240" elevation="7" :style="{ 'border-left': 'solid 5px' + item.color_nivel }" >
                        <v-list-item>
                            <v-list-item-avatar class="ml-0 mr-1" size="50" :color="item.color_curso">
                                <v-icon dark>{{item.icono_curso}}</v-icon>
                            </v-list-item-avatar>

                            <v-list-item-content class="py-0">
                                <span class="mb-1 black--text"><h5>{{item.desc_curso}}</h5></span>
                                <v-list-item-title class="caption">Área: {{item.desc_area}}</v-list-item-title>
                                <!-- <v-list-item-subtitle>Clicken1</v-list-item-subtitle> -->
                            </v-list-item-content>
                        </v-list-item>


                        <v-card-text :style="{background:item.color_nivel}" id="text" >
                            {{item.nombre_pais}} - {{item.nivel}} - {{item.grado}}
                        </v-card-text>


                        <v-card-actions>
                            <v-row>
                                <v-spacer></v-spacer>

                                <v-col cols="12" md="6" class="pb-md-0 pt-1">
                                    <v-tooltip bottom color="#1b1b1b">
                                        <template v-slot:activator="{ on }">
                                            <v-btn v-if="componenteEvento.editar_submodulo" v-on="on" class="btn_editar mx-2" fab x-small @click="editCurso(item)">
                                                <v-icon>fa-pencil-alt</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>EDITAR CURSO</span>
                                    </v-tooltip>


                                    <v-tooltip bottom color="#1b1b1b">
                                        <template v-slot:activator="{ on }">
                                            <v-btn v-if="componenteEvento.borrar_submodulo" v-on="on" class="btn_eliminar mx-2" fab x-small @click="deleteConfirm(item)">
                                                <v-icon>fa-trash-alt</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>BORRAR CURSO</span>
                                    </v-tooltip>
                                </v-col>
                            </v-row>

                        </v-card-actions>

                    </v-card>
                </v-col>
            </v-row>

        </v-card>






        <!-- MODAL CREAR editar curso -->
        <v-form ref="formDatos" lazy-validation>
            <v-dialog v-model="dialog" scrollable persistent max-width="750">
                <v-card>
                    <v-card-title class="btn_otro">
                        <v-row class="d-flex justify-space-between py-0">
                            {{ formTitle }}
                            <v-btn fab dark x-small class="btn_style3" @click="dialog=false"><v-icon dark>fa-times</v-icon></v-btn>
                        </v-row>
                    </v-card-title>

                    <v-divider></v-divider>

                    <v-card-text>

                        <!-- {{dataForm}} -->
                        <v-row>
                            <v-col cols="12" lg="6" class="py-0">
                               <v-autocomplete
                               @change="getNivelesPaisArea(dataForm.id_pais)"
                                v-model="dataForm.id_pais"
                                label="País"
                                :items="paisCreated"
                                item-value="id"
                                item-text="nombre_pais"
                                :readonly="disabledPais"
                                :rules="[rul.selectReq]"
                                autocomplete="off">
                                </v-autocomplete>
                            </v-col>


                            <v-col cols="12" lg="6" class="py-0">
                                <v-autocomplete
                                @change="getAllGradosNivel(dataForm.id_nivel_pais)"
                                v-model="dataForm.id_nivel_pais"
                                label="Nivel"
                                :items="NivelesAreas"
                                item-text="desc_nivel"
                                :rules="[rul.selectReq]"
                                item-value="id"
                                :readonly="disabledNivel"
                                autocomplete="off">
                                </v-autocomplete>
                            </v-col>


                            <v-col cols="12" lg="12" class="py-0">
                                <v-autocomplete label="Grados" v-model="dataForm.id_grado" :items="Grados_nivel"
                                item-text="desc_grado"  item-value="id"
                                :readonly="disabledGrados" multiple autocomplete="off" :rules="[rul.selectReq]"

                                ></v-autocomplete>
                            </v-col>


                            <v-col cols="12" lg="6" class="py-0">
                                <v-autocomplete
                                label="Área"
                                v-model="dataForm.id_area"
                                :items="AreasPais"
                                item-text="desc_area"
                                item-value="id"
                                prepend-icon
                                :rules="[rul.selectReq]"
                                :readonly="disabledArea"
                                autocomplete="off"
                                ></v-autocomplete>
                            </v-col>


                            <v-col cols="12" lg="6" class="py-0">
                                <v-text-field
                                label="Nombre"
                                v-model="dataForm.desc_curso"
                                :rules="[rul.required, rul.max100]"
                                ></v-text-field>
                            </v-col>



                            <v-col cols="12" lg="6" class="py-0">
                                <v-row>
                                    <v-col class="">
                                        <label class="black--text"><h3>Seleccionar Color</h3> </label>
                                    </v-col>
                                </v-row>

                                <v-color-picker v-model="dataForm.color_curso"></v-color-picker>
                            </v-col>


                            <v-col cols="12" lg="6" class="py-0">
                                <v-row>
                                    <v-col class="">
                                        <label class="black--text"><h3>Seleccionar ícono</h3> </label>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col cols="6" md="3" lg="2" v-for="icon of iconos" :key="icon.id">
                                        <v-card class="text-center pt-1 pb-1" @click="agregarIcono(icon.nombre)">
                                            <v-icon :style="{color:dataForm.color_curso}">{{icon.nombre}}</v-icon>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-col>


                            <v-row>
                                <v-col cols="5" class="text-center"></v-col>

                                <v-col cols="2" class="text-center">
                                    <v-card :color="dataForm.color_curso" class="pt-3 pb-3">
                                        <v-icon large dark>{{dataForm.icono_curso}}</v-icon>
                                    </v-card>
                                </v-col>

                                <v-col cols="5" class="text-center"></v-col>
                            </v-row>
                        </v-row>
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-spacer></v-spacer>

                        <v-btn class="btn_block_style2" dark  v-if="this.evento=='editar'"  @click="updateCurso(dataForm.id)">Guardar Cambios</v-btn>
                        <v-btn class="btn_block_style2" dark  v-if="this.evento=='agregar'" @click="addCurso">Guardar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-form>




    </div>
</template>





<script>
    import axios from "@/helpers/axios";
    import {mapMutations, mapGetters, mapActions, mapState} from 'vuex';

    export default {
        name: "listadoDocente",

        data: () => ({
            //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
            paramComponente:{ 'id_submodulo':32, "id_modulo": 4}, //sud_modulo y modulo

            datoLogin: sessionStorage, // variables de sesion del usuario
            test:false,
            ////////////////////////////////////////////////////////


            //// CONSULTA PRINCIPAL
            filtro:{id_pais:null, id_nivel:null, id_area:null},
            paisFiltro: [],

            NivelesSearch:[],
            disabledNivelSearch:true,

            AreasSearch:[],
            disabledAreaSearch:true,

            Datos:[],
            ////////////////////////



            //// MODAL AGREGAR EDITAR CURSO
            dialog: false,
            evento: '',
            dataForm: [],

            paisCreated:  [],
            NivelesAreas: [],
            Grados_nivel: [],
            AreasPais:    [],

            disabledPais:   false,
            disabledNivel:  false,
            disabledGrados: false,
            disabledArea:   false,

            paramsAreas:{"id_pais":null,"id_nivel":null},
            /////////////////////////////////////


            //// MODAL CONFIRMACION
            dialog_delete:false,
            id_delete:null,
            name_delete:'',
            /////////////////////////////////////


             //validaciones de formulario
            rul: {
                required: value => !!value || 'Campo requerido',
                inputReq: value => !!value || 'Campo requerido',
                selectReq: value => !!value || 'Debe seleccionar un campo de la lista',
                email: value => /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/.test(value) || 'El correo es incorrecto',
                min4: v => (v || '').length >= 4 || 'Mínimo 4 caracteres',
                min6: v => (v || '').length >= 6 || 'Mínimo 6 caracteres',
                min8: v => (v || '').length >= 8 || 'Mínimo 8 caracteres',
                max10: v => (v || '').length <= 10 || 'Máximo 10 caracteres',
                max11: v => (v || '').length <= 11 || 'Máximo 11 caracteres',
                max12: v => (v || '').length <= 12 || 'Máximo 12 caracteres',
                max20: v => (v || '').length <= 20 || 'Máximo 20 caracteres',
                max30: v => (v || '').length <= 30 || 'Máximo 30 caracteres',
                max50: v => (v || '').length <= 50 || 'Máximo 50 caracteres',
                max60: v => (v || '').length <= 60 || 'Máximo 60 caracteres',
                max100: v => (v || '').length <= 100 || 'Máximo 100 caracteres',
                max150: v => (v || '').length <= 150 || 'Máximo 150 caracteres',

                email_null: value => {
                    if(value == '') {
                        return false
                    }
                    else{
                        const pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/
                        return pattern.test(value) || 'Invalid e-mail.'
                    }
                },
            },
        }),


        computed: {
            formTitle() {
                return this.evento === 'agregar' ? "CREAR CURSO" : "EDITAR CURSO";
            },

            ...mapGetters('login', [ 'componenteEvento']),

            ...mapState({
                iconos: state => state.areas.iconos
            })
        },


        mounted() {
            this.getPais()
            this.filtrarView()
        },


        created() {
            this.actualizarParamentro()
        },



        methods: {
            //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
            //----- Validar accesos por perfil ------------
            ...mapActions('login',['parametroComponente'] ),

            actualizarParamentro() {
                this.parametroComponente(this.paramComponente)
            },

            //  ------- MENSAJE DE SISTEMA  --------
            ...mapMutations('mensajeSis', ['setEnviarMens']),
            ////////////////////////////////////////////////////////


            //-----------obtener paises----------------------------
            async getPais(){
                try{
                    let response = await axios.get("/mantenimiento/paises/paisesConfigurados/")
                    this.paisCreated  = response.data;

                    let objectNew = JSON.parse(JSON.stringify(response.data))

                    objectNew.unshift({
                        "id":null,
                        "nombre_pais":"Todos",
                    })
                    this.paisFiltro = objectNew

                }

                catch(error){
                    this.setEnviarMens({tipo:"E", mensaje: `${error}`, tiempo:null})
                    //console.log(error);
                }
            },



            //-------filtar pais, nivel, area------------
            async filtrarView(){
                try{
                    const response = await axios.post("/manager/cursoCkOne/view",this.filtro);
                    this.Datos = response.data
                }

                catch(e){
                    this.setEnviarMens({tipo:"E", mensaje: `${e}`, tiempo:null})
                }
            },


            //-------  filtrar cursos ------------
            async eventFiltroPais(){
                this.disabledAreaSearch  = true
                this.filtro.id_nivel     = null
                this.filtro.id_area      = null

                if(this.filtro.id_pais == null){
                    this.disabledNivelSearch = true
                }

                else{
                    this.disabledNivelSearch = false
                    this.getNivelesSeach()
                }

                await this.filtrarView()

                if(this.Datos.length  == 0){
                    this.setEnviarMens({tipo:"W", mensaje:'No existe información para éste país ', tiempo:null})
                    this.disabledNivelSearch = true
                    this.disabledAreaSearch  = true
                    this.filtro.id_nivel     = null
                    this.filtro.id_area      = null
                }
            },
            // ------ end filtrar cursos  -------- //



            //************ traer nieveles por pais  PARA CONSULTAR AREA ******/
            async getNivelesSeach(){
                try{
                    const response = await axios.get('/manager/nivelCkOne/pais/'+this.filtro.id_pais)

                    if(response.data.length > 0){
                        this.disabledNivelSearch = false
                        let objectNew = JSON.parse(JSON.stringify(response.data))

                        objectNew.unshift({
                            "id":null,
                            "desc_nivel":"Todos",
                        })
                        this.NivelesSearch =  objectNew
                    }

                    else{
                        this.disabledNivelSearch = true
                    }
                }

                catch(e){
                    this.setEnviarMens({tipo:"E", mensaje: `${e}`, tiempo:null})
                }
            },
            //////////////////////////////////////////////////////////





            //////////  filtro areas por nivel //////////
            async eventFiltroNivel(){
                try{
                    if(this.filtro.id_nivel){
                        const response = await axios.post("/manager/areaCkOne/pais/",this.filtro)
                        let objectNew = JSON.parse(JSON.stringify(response.data))

                        objectNew.unshift({
                            "id":null,
                            "desc_area":"Todos",
                        })

                        this.AreasSearch =  objectNew
                        this.disabledAreaSearch = false
                    }

                    else{
                        this.disabledAreaSearch = true
                    }

                    await this.filtrarView()

                    if(this.Datos.length  == 0){
                        this.setEnviarMens({tipo:"W", mensaje:'No existe información para éste nivel ', tiempo:null})
                        this.disabledAreaSearch  = true
                        this.filtro.id_area      = null
                    }
                }

                catch(e){
                    this.setEnviarMens({tipo:"E", mensaje: `${e}`, tiempo:null})
                }
            },
            /////////////////////////////////////////////////////////




            //////////  filtro cursos por areas nivel y pais //////////
            async eventFiltroArea(){
                await this.filtrarView()

                if(this.Datos.length  == 0){
                    this.setEnviarMens({tipo:"W", mensaje:'No existe información para ésta área ', tiempo:null})
                }
            },
            /////////////////////////////////////////////////////////




            async limpiarForm(){
                this.dataForm = {id_colegio: 0, // 18-02-2020. Robert. Se Setea 0 por ser manager
                                 id_pais: '', id_nivel_pais: '', id_grado: [],
                                 id_area: '', desc_curso: "", icono_curso: "", color_curso: "#0277BD",
                                 id_us_ing: this.datoLogin.id, //18-02-2020. Robert. Se vincula con el usuario en session.
                                 fec_us_ing: "", id_us_mod: this.datoLogin.id, //18-02-2020. Robert. Se vincula con el usuario en session.
                                 fec_us_mod: "",  estado: 1, ck1: true
                },

                this.$refs.formDatos.resetValidation()

                this.paisCreated  = []
                this.NivelesAreas = []
                this.Grados_nivel = []
                this.AreasPais    = []

                this.disabledPais   = false
                this.disabledNivel  = true
                this.disabledGrados = true
                this.disabledArea   = true
            },




            addItem(){
                this.limpiarForm()
                this.evento = 'agregar'
                this.dialog = true

                this.getPais()
            },



            //************ traer nieveles por pais  PARA CONSULTAR AREA ******/
            async getNivelesPaisArea(id){

                if(this.evento == 'agregar'){
                    this.disabledNivel = false

                    this.NivelesAreas = []
                    this.Grados_nivel = []
                    this.AreasPais    = []
                    this.dataForm.id_nivel_pais = ''
                    this.dataForm.id_grado        = []
                    this.dataForm.id_area       = ''
                }

                try{
                    const response = await axios.get('/manager/nivelCkOne/pais/'+id);
                    this.NivelesAreas = response.data
                }

                catch(e){
                    this.setEnviarMens({tipo:"E", mensaje: `${e}`, tiempo:null})
                }
            },


            //////////////   traer grados segun nivel  //////////////
            async getAllGradosNivel(id){
                if(this.evento == 'agregar'){
                    this.disabledGrados = false

                    this.Grados_nivel = []
                    this.AreasPais    = []
                    this.dataForm.id_grado = []
                    this.dataForm.id_area  = ''
                }

                try{
                    let response = await axios.get("/manager/gradoCkOne/grados/"+id+"")
                    this.Grados_nivel = response.data
                    //this.disabledGrados = true ? this.Grados_nivel.length === 0 : false;

                    await this.getAreasPais();
                    //console.log(this.Grados_nivel)
                }
                catch(e){
                    this.setEnviarMens({tipo:"E", mensaje: `${e}`, tiempo:null})
                }
            },


            //////////  traer areas por Pais //////////
            async getAreasPais(){
                this.paramsAreas.id_pais = this.dataForm.id_pais
                this.paramsAreas.id_nivel = this.dataForm.id_nivel_pais

                try{
                    const response = await axios.post("/manager/areaCkOne/pais/",this.paramsAreas);
                    this.AreasPais = response.data

                    if(this.evento == 'agregar'){
                        this.disabledArea = false
                    }
                    //console.log(JSON.stringify(this.AreasPais));
                }

                catch(e){
                    this.setEnviarMens({tipo:"E", mensaje: `${e}`, tiempo:null})
                }
            },


            // seleccion de icono para guardar
            agregarIcono(icono) {
                this.dataForm.icono_curso = icono
            },




            //-----------crear Cursos de trabajo--------------
            async addCurso() {
                if(!this.dataForm.icono_curso){
                    this.setEnviarMens({tipo:"W", mensaje: 'Seleccionar un ícono', tiempo:null})
                }

                else{
                    if (this.$refs.formDatos.validate()) {
                        //let params = this.arrayData
                        let params = this.dataForm

                        try{
                            let res = await axios.post("/manager/cursoCkOne/addArrayCurso",params)

                            if( res.data.messageT =="S"){
                                this.dialog = false
                                this.eventFiltroArea()
                                this.limpiarForm()
                            }
                            this.setEnviarMens({tipo:res.data.messageT, mensaje: `${res.data.message}`, tiempo:null})

                        }
                        catch(e){
                            this.setEnviarMens({tipo:"E", mensaje: `${e}`, tiempo:null})
                        }
                    }
                }
            },



            // MODAL EDITAR CURSO
            editCurso(item) {
                this.limpiarForm()

                this.evento = 'editar'
                this.dataForm = item
                this.dataForm.id_nivel_pais = item.id_nivel

                this.getPais()
                this.getNivelesPaisArea(item.id_pais)
                this.getAllGradosNivel(item.id_nivel_pais)

                this.dialog = true
                this.disabledPais = true
            },



            //--------------editar curso--------------
            async updateCurso() {
                if(!this.dataForm.icono_curso){
                    this.setEnviarMens({tipo:"W", mensaje: 'Seleccionar un ícono', tiempo:null})
                }

                else{
                    if (this.$refs.formDatos.validate()) {
                        //let params = this.arrayData
                        let params = this.dataForm

                        try{
                            let res = await axios.put("/manager/cursoCkOne/"+params.id,params)

                            if( res.data.messageT =="S"){
                                this.dialog = false
                                this.eventFiltroArea()
                                this.limpiarForm()
                            }
                            this.setEnviarMens({tipo:res.data.messageT, mensaje: `${res.data.message}`, tiempo:null})

                        }
                        catch(e){
                            this.setEnviarMens({tipo:"E", mensaje: `${e}`, tiempo:null})
                        }
                    }
                }
            },


            // modal para confirmar el borrar el registro
            deleteConfirm(item){
                this.dialog_delete = true
                this.id_delete   =  item.id
                this.name_delete = `Curso: ${item.desc_curso}`;
              //  this.desc_delete = `${items.descripcion_perfil} - (${items.id})`

            },



            //------------borrar curso -------------
            async deleteCurso() {
                try {
                    let response = await axios.delete("/manager/cursoCkOne/"+this.id_delete)
                    this.eventFiltroArea()
                    this.dialog_delete = false
                    this.setEnviarMens({tipo:response.data.messageT, mensaje: response.data.message, tiempo:null})
                }

                catch (e) {
                    this.setEnviarMens({tipo:"E", mensaje: `${e}`, tiempo:null})
                }
            },

        }
    };
</script>



<style scoped>
    #text{
        color:#ffffff;
        padding:1%;
        padding-left:10%;
    }


    /***** media query *******/
    .card-new{
        width:240px;
    }


    @media (min-width:325px)and(max-width: 425px){
        .card-new{
            width: 100%;
        }
    }

    @media (min-width:325px)and(max-width: 425px){
        .card-new{
            width: 100%;
        }
    }

    @media (min-width:426px)and(max-width: 640px){
        .card-new{
            width: 100%;
        }
    }

    @media (min-width:641px)and(max-width: 768px){
        .card-new{
            width: 100%;
        }
    }

    @media (min-width:769px)and(max-width: 1024px){
        .card-new{
            width: 100%;
        }
    }
</style>